import { Ingredients } from '@widgets/Ingredients/types'

const isRecipeIngredientValid = (
  recipeIngredients: any
): recipeIngredients is Ingredients => recipeIngredients?.length > 0

export { isRecipeIngredientValid }
